import { render } from "./GeneralPage.vue?vue&type=template&id=6e761245&scoped=true"
import script from "./GeneralPage.vue?vue&type=script&lang=js"
export * from "./GeneralPage.vue?vue&type=script&lang=js"

import "./GeneralPage.vue?vue&type=style&index=0&id=6e761245&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e761245"]])

export default __exports__